export const urlLogin = 'login';
export interface IAliyunOSSSignature {
    accessid: string;
    dir: string;
    expire: number;
    host: string;
    policy: string;
    signature: string;
    callback: string;
  }

/**
 * 阿里云保存封面、附件
 */
export const urlAliyunOSSThumb: string = '/api/design/osssign/getsign';